<template>
  <footer class="footer">
    <div class="footer__inner _cnt">
      <div class="footer__top">
        <div class="footer__info">
          <router-link to="/" class="footer__logo">
            <img src="./../img/footer-logo.svg" class="img" />
          </router-link>
          <div class="footer__text">
            {{
              $t(
                'Сервер для выживания и творчества. Честная экономика, уютное сообщество и донат только за косметику.',
              )
            }}
          </div>
          <div class="footer__methods">
            <div class="footer__method">
              <img
                src="./../img/methods/sbp.png"
                :alt="$t('СБП')"
                class="footer__method-logo footer__method-logo_sbp"
              />
            </div>
            <div class="footer__method">
              <img
                src="./../img/methods/visa-white.svg"
                :alt="$t('VISA')"
                class="footer__method-logo footer__method-logo_visa"
              />
            </div>
            <div class="footer__method">
              <img
                src="./../img/methods/mc.svg"
                :alt="$t('MC')"
                class="footer__method-logo footer__method-logo_mc"
              />
            </div>
            <div class="footer__method">
              <img
                src="./../img/methods/mir.png"
                :alt="$t('МИР')"
                class="footer__method-logo footer__method-logo_mir"
              />
            </div>
          </div>
        </div>
        <div class="footer__links">
          <div class="footer__label">{{ $t('Навигация') }}</div>
          <router-link class="footer__link" to="/" exact>
            <b>{{ $t('Главная') }}</b>
          </router-link>
          <button
            @click="$emit('chooseCategoty', $parent.categories[0])"
            class="footer__link"
          >
            <b>{{ $t('Магазин') }}</b>
          </button>
          <router-link class="footer__link" to="/rules">
            <b>{{ $t('Правила') }}</b>
          </router-link>
          <router-link class="footer__link" to="/faq">
            <b>{{ $t('FAQ') }}</b>
          </router-link>
        </div>
        <div class="footer__links">
          <div class="footer__label">{{ $t('Документы') }}</div>
          <a
            v-for="item in $parent.textPageList"
            :key="item.id"
            class="footer__link"
            @click="$parent.goToPage(item)"
          >
            <b>{{ item.title }}</b>
          </a>
        </div>
        <div class="footer__about">
          <div class="footer__label">{{ $t('Контакты') }}</div>
          <div class="footer__requisites" v-if="settings">
            {{ settings.requisites }}
          </div>
          <a
            :href="'mailto:' + settings.support_email"
            class="footer__email"
            v-if="settings"
          >
            <b>{{ settings.support_email }}</b>
          </a>
          <a
            v-if="$parent.settings.support_phone"
            :href="
              'tel:' +
              (($parent.settings.support_phone &&
                $parent.settings.support_phone.replace(/[\s()-]/g, '')) ||
                '')
            "
            class="footer__email"
          >
            <b>{{ $parent.settings.support_phone }}</b>
          </a>
          <div class="footer__text">
            {{ $t('Для предложений о сотрудничестве:') }}
            <a href="mailto:partners@bloxnest.online" class="footer__email">
              <b>partners@bloxnest.online</b>
            </a>
          </div>
        </div>
      </div>
      <div class="footer__copy" v-if="settings">
        {{ settings.copyright }}
      </div>
      <ul
        class="socials"
        v-if="$parent.socialLinks && $parent.socialLinks.length && false"
      >
        <li
          v-for="link in $parent.socialLinks"
          :key="link.img"
          class="nav__item nav__item-text-pages"
        >
          <a :href="link.link" class="desc" target="_blank">
            <img :src="link.img" :alt="link.link" class="img" />
          </a>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: ['settings'],
  data: function () {
    return {}
  },
  methods: {},
  mounted() {},
}
</script>

<style lang="scss" scoped>
.footer {
  padding: 56px 0px 32px;
  @media (max-width: 991.98px) {
    padding: 35px 0px 25px;
  }
  @media (max-width: 767.98px) {
    padding: 25px 0px;
  }
  &__inner {
  }

  &__top {
    display: flex;
    gap: 20px;
    justify-content: space-between;
    &:not(:last-child) {
      margin-bottom: 44px;
    }
    @media (max-width: 991.98px) {
      flex-wrap: wrap;
      &:not(:last-child) {
        margin-bottom: 24px;
      }
    }
    @media (max-width: 767.98px) {
      &:not(:last-child) {
        margin-bottom: 15px;
      }
    }
  }

  &__info {
    flex: 0 1 25%;
    @media (max-width: 991.98px) {
      order: 1;
      flex: 0 1 calc(50% - 10px);
    }
    @media (max-width: 619.98px) {
      flex: 1 1 100%;
    }
  }
  &__logo {
    display: block;
    width: fit-content;
    min-width: 126px;
    height: 34px;
    &:not(:last-child) {
      margin-bottom: 15px;
    }
  }

  &__text {
    font-weight: 500;
    color: var(--mantle);
    line-height: 22px;
    font-size: 14px;
    font-family: var(--font-1);
    &:not(:last-child) {
      margin-bottom: 15px;
    }
  }

  &__methods {
    display: flex;
    gap: 26px;
    flex-wrap: wrap;
    @media (max-width: 991.98px) {
      gap: 10px;
    }
  }

  &__method {
    background-color: var(--heavy-metal);
    border-radius: 10px;
    min-height: 38px;
    min-width: 62px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    border: 1px solid var(--outer-space);
    font-family: var(--font-2);
    color: var(--conch);
    font-size: 15px;
    font-weight: 700;
    line-height: 20px;
    padding: 5px 10px;
  }

  // Официальные логотипы платёжных систем, версии для тёмного фона.
  // Высоты подобраны так, чтобы знаки выглядели одинаково весомыми.
  &__method-logo {
    display: block;
    width: auto;

    &_sbp {
      height: 20px;
    }
    &_visa {
      height: 14px;
    }
    &_mc {
      height: 22px;
    }
    &_mir {
      height: 12px;
    }
  }

  &__links {
    @media (max-width: 991.98px) {
      order: 3;
      flex: 0 1 calc(50% - 10px);
    }
    @media (max-width: 429.98px) {
      flex: 1 1 100%;
    }
  }

  &__label {
    font-size: 15px;
    font-weight: 700;
    font-family: var(--font-2);
    color: var(--gray-nurse);
    line-height: 20px;
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }

  &__link {
    display: block;
    text-align: left;
    width: 100%;
    font-family: var(--font-1);
    background-color: transparent;
    outline: transparent;
    color: var(--pewter);
    font-size: 14px;
    line-height: 19px;
    padding: 6px 0px;
    white-space: nowrap;
    transition: color 0.3s ease 0s;
    &.router-link-active {
      color: var(--gray-nurse);
      pointer-events: none;
    }
    @media (any-hover: hover) {
      &:hover {
        color: var(--gray-nurse);
      }
    }
  }

  &__about {
    flex: 0 1 25%;
    @media (max-width: 991.98px) {
      order: 2;
      flex: 0 1 calc(50% - 10px);
    }
    @media (max-width: 619.98px) {
      flex: 1 1 100%;
    }
  }

  &__requisites {
    color: var(--pumice);
    font-family: var(--font-1);
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    &:not(:last-child) {
      margin-bottom: 6px;
    }
  }
  &__email {
    display: block;
    width: fit-content;
    white-space: nowrap;
    color: var(--pumice);
    font-family: var(--font-1);
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    padding: 6px 0px;
    @media (any-hover: hover) {
      &:hover {
        color: var(--44);
      }
    }
  }

  &__copy {
    padding-top: 24px;
    border-top: 1px solid var(--outer-space);
    font-size: 13px;
    line-height: 18px;
    color: var(--corduroy);
  }
}
</style>
